// Lifestyle shots — kid/adult actually wearing the piece.
// Used by shop tiles + featured tiles so we don't only show flat garment shots.
export const LIFESTYLE_MAP = {
  "butterfly-bliss-pink": "/api/uploads/butterfly-bliss-pink/generated/frame-001.webp",
  "butterfly-bliss-lilac": "/api/uploads/_lifestyle/girls/g-5.webp",
  "twilight-hoot-lilac": "/api/uploads/_lifestyle/girls/g-image-1.webp",
  "twilight-hoot-pink": "/api/uploads/_lifestyle/girls/g-19.webp",
  "dragonfly-lilac": "/api/uploads/_lifestyle/girls/g-4.webp",
  "dearmy-hearts": "/api/uploads/_lifestyle/girls/g-20.webp",
  // Lovely Lotus Pink & Purple: keep the studio-plinth hero on tiles for
  // visual consistency between the two colourways. Kid photo lives on the
  // product page as a supporting image.
  "emerald-grace": "/api/uploads/_lifestyle/set2/s2-1.webp",
  "magenta-twilight": "/api/uploads/_lifestyle/set2/s2-14.webp",
  "busy-bee-shirt-mint": "/api/uploads/busy-bee-shirt-mint/lifestyle/lifestyle-candlelit.webp",
  "crazy-car-shirt-white": "/api/uploads/crazy-car-shirt-white/lifestyle/lifestyle-full.webp",
};

export const lifestyleFor = (slug, fallback) => LIFESTYLE_MAP[slug] || fallback;
